package pl.decks.chartjs.radar.builder

import pl.decks.chartjs.radar.dataset.RadarDataSet
import pl.decks.chartjs.value.ClipValue

@RadarDsl
class RadarDataSetBuilder(
    private val label: String,
    private val data: List<Number>,
) {
    private var lineScope: LinePropertiesScope = LinePropertiesScope()
    private var lineHoverScope: LineHoverScope? = null
    private var pointScope: PointPropertiesScope = PointPropertiesScope()
    private var pointHoverScope: PointHoverScope? = null
    var order: Int = 0
    var clip: ClipValue? = null

    fun line(block: LinePropertiesScope.() -> Unit) {
        lineScope = LinePropertiesScope().apply(block)
    }

    @Suppress("unused")
    fun lineHover(block: LineHoverScope.() -> Unit) {
        lineHoverScope = LineHoverScope().apply(block)
    }

    fun point(block: PointPropertiesScope.() -> Unit) {
        pointScope = PointPropertiesScope().apply(block)
    }

    fun pointHover(block: PointHoverScope.() -> Unit) {
        pointHoverScope = PointHoverScope().apply(block)
    }

    internal fun build() = RadarDataSet(
        label = label,
        data = data,
        order = order,
        clip = clip,
        line = lineScope.build(),
        lineHover = lineHoverScope?.build(),
        point = pointScope.build(),
        pointHover = pointHoverScope?.build(),
    )
}
